import React, { PropsWithChildren } from "react";
import SideBar from "./sidebar";
import AuthFooter from "src/components/@auth/auth-layout";

export interface InvitedData {
  invited: string;
  email: string;
  organization_name: string;
  role: string;
  organization_industry: string;
}

interface SignUpLayoutProps extends PropsWithChildren {
  currentStep: number; // Current active step index
  completedSteps: number[]; // Indices of completed steps
  invitedData?: InvitedData;
}

const SignUpLayout: React.FC<SignUpLayoutProps> = ({
  children,
  currentStep,
  completedSteps,
  invitedData = null,
}) => {
  return (
    <div className="flex">
      {/* Pass currentStep and completedSteps to the SideBar */}
      <SideBar
        invitedData={invitedData || null}
        currentStep={currentStep}
        completedSteps={completedSteps}
      />
      <div className="flex-1  flex-col flex  p-2">
        <div className="h-full">
        {children}
        </div>

        <AuthFooter />
      </div>
    </div>
  );
};

export default SignUpLayout;
